import { useMemo } from "react";

import useSelectorWithUrlParams from "src/common/hooks/useSelectorWithUrlParams";
import { projectCapabilitySelector } from "src/reducers/project/capabilities";

import { parseTimeDuration } from "../utils/parseDimensions/parseDimensions";

import useMetricsLinkData from "./useMetricsLinkData";

/**
 * Get the Maximum Range of metrics supported by
 * this subscription
 * @returns ParsedRangeType
 */
const useMetricsMaxDuration = () => {
  const { max_range } = useMetricsLinkData();
  const capabilities = useSelectorWithUrlParams(projectCapabilitySelector);
  return useMemo(() => {
    return parseTimeDuration(max_range || capabilities?.metrics?.max_range);
  }, [capabilities?.metrics?.max_range, max_range]);
};

export default useMetricsMaxDuration;
